import Vue from 'vue';
import App from './App.vue';
import VueTippy from 'vue-tippy';
import VDragged from 'v-dragged';
import VueI18n from 'vue-i18n';
import VueMaterial from 'vue-material';
import labels from './labels/labels';


Vue.config.productionTip = false;
Vue.use(VueTippy);
Vue.use(VueI18n);
Vue.use(VueMaterial);
Vue.use(VDragged);
Vue.component('MdSelect', Vue.options.components.MdSelect.extend({
  methods: {
    isInvalidValue: function isInvalidValue() {
      return this.$el.validity ? this.$el.validity.badInput : this.$el.querySelector('input').validity.badInput
    }
  }
}));

const userLang = navigator.language || navigator.userLanguage;

const i18n = new VueI18n({
  locale: userLang === 'fr' ? 'fr' : 'en',
  messages: labels,
})

new Vue({ i18n, render: h => h(App) }).$mount('#app')
export default i18n;


// WEBPACK FOOTER //
// ./src/main.js